import { render, staticRenderFns } from "./sold.vue?vue&type=template&id=4345ad62&"
import script from "./sold.vue?vue&type=script&lang=js&"
export * from "./sold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports